// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  width: 100%;
}
.social-nav {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin: 10px 0;
}

.social-nav__btn {
  width: 50px;
}

.social-nav__btn img {
  width: 100%;
}

.social-nav-btns.about-me {
  display: flex;
  justify-content: space-around;
  width: 50%;
}

#root > div > main > div > div > nav > a:nth-child(1) > img {
  height: 45px;
  margin: 4px 0 0 0;
}

/* label {
	display: flex;
	flex-direction: column-reverse;
	align-items: center;
	color: black;
} */
`, "",{"version":3,"sources":["webpack://./src/components/elements/social-media-nav/social-media-nav.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;;;;GAKG","sourcesContent":["nav {\n  width: 100%;\n}\n.social-nav {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  margin: 10px 0;\n}\n\n.social-nav__btn {\n  width: 50px;\n}\n\n.social-nav__btn img {\n  width: 100%;\n}\n\n.social-nav-btns.about-me {\n  display: flex;\n  justify-content: space-around;\n  width: 50%;\n}\n\n#root > div > main > div > div > nav > a:nth-child(1) > img {\n  height: 45px;\n  margin: 4px 0 0 0;\n}\n\n/* label {\n\tdisplay: flex;\n\tflex-direction: column-reverse;\n\talign-items: center;\n\tcolor: black;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
